import { Box, Typography, Button } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import type { FallbackProps } from 'react-error-boundary';

function getErrorMessage(error: unknown): string {
    if (error instanceof Error) {
        return error.message;
    }
    if (typeof error === 'string') {
        return error;
    }
    return 'An unknown error occurred';
}

export function ErrorFallback({ error, resetErrorBoundary }: FallbackProps) {
    return (
        <Box
            role="alert"
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: '100vh',
                p: 4,
                textAlign: 'center',
                bgcolor: 'background.default'
            }}
        >
            <ErrorOutlineIcon sx={{ fontSize: 64, color: 'error.main', mb: 2 }} />
            <Typography variant="h4" color="error" gutterBottom>
                Something went wrong
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3, maxWidth: 500 }}>
                An unexpected error occurred. Please try again.
            </Typography>
            <Typography variant="caption" color="text.disabled" sx={{ mb: 3, fontFamily: 'monospace' }}>
                {getErrorMessage(error)}
            </Typography>
            <Button variant="contained" onClick={resetErrorBoundary}>
                Try Again
            </Button>
        </Box>
    );
}
